import { useTranslations } from '@heidi/runtime/i18n';
import { useCPDTerm } from './useCPDTerm';

/**
 * Hook that provides translations with CPD/CME terminology automatically replaced
 * based on user's country. US users see "CME", all others see "CPD".
 */
export function useCPDTranslations(isUS: boolean) {
  const { t: baseT } = useTranslations();
  const { term } = useCPDTerm(isUS);

  const t = (key: string, options?: Record<string, unknown>) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-argument
    const translation = baseT(key as any, options);
    // Replace "CPD" with the appropriate term (CPD or CME)
    if (typeof translation === 'string') {
      return translation.replace(/CPD/g, term);
    }
    return translation;
  };

  return { t, term };
}
